import { render, staticRenderFns } from "./LimitlessTabs.vue?vue&type=template&id=7d53b529&scoped=true&"
import script from "./LimitlessTabs.vue?vue&type=script&lang=js&"
export * from "./LimitlessTabs.vue?vue&type=script&lang=js&"
import style0 from "./LimitlessTabs.vue?vue&type=style&index=0&id=7d53b529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53b529",
  null
  
)

export default component.exports